import { Box } from '@mui/material';
import { useFormContext } from 'framework/form';
import { Button } from 'framework/ui/mui-builder';
import { Modal, SubmitButton } from 'framework/ui/ui-builder';
import StaffingAssignmentForm from '../StaffingAssignmentForm';

const CreateStaffingAssignmentModalContent = ({
  setOpen,
  isVirtual,
}: {
  setOpen: (open: boolean) => void;
  isVirtual?: boolean;
}) => {
  const { submitForm, isSubmitEnabled = true, isLoadingArtifact } = useFormContext();

  return (
    <Modal
      isOpen={true}
      onToggle={() => setOpen(false)}
      paperStyles={{
        background: 'var(--mui-palette-background-paper)',
      }}
      title={`Create ${isVirtual ? 'planned ' : ''}assignment`}
    >
      <StaffingAssignmentForm isCreateForm={true} isVirtual={isVirtual} />
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2, pt: 1 }}>
        <Button variant="outlined" onClick={() => setOpen(false)} disabled={!isSubmitEnabled || isLoadingArtifact}>
          Cancel
        </Button>
        <SubmitButton onClick={submitForm} isLoading={!isSubmitEnabled} disabled={isLoadingArtifact} />
      </Box>
    </Modal>
  );
};

export default CreateStaffingAssignmentModalContent;
